import repository from './repsitory'

const resource = '/persons'
export default {
    get () {
        return repository.get(`${resource}`)
    },
    getById (id) {
        return repository.get(`${resource}/${id}`)
    },
    addPerson (data) {
        return repository.post(`${resource}`, data)
    },
    updatePerson (data, id) {
        return repository.put(`${resource}/${id}`, data)
    },
}
